import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import "./LocationLabel.css";

// Hardcoded tooltips (static)
const tooltips = [
  { name: "Internal Road", coords: "project6BaseCoords", className: "project-8-label", transform: "translate(-50%, -100%)", isBold: true },
  { name: "Main Road", coords: "c1", className: "project-5-label" },
  { name: "Main Road", coords: "c2", className: "project-5-label" },
  { name: "🏡", coords: "c3", className: "i-label" },
  { name: "🏟️", coords: "c4", className: "i-label" },
  { name: "Phase 2", coords: "c5", className: "p-label" },
  { name: "Phase 2", coords: "c6", className: "p-label" },
  { name: "Phase 3", coords: "c7", className: "p-label" },
];

// Hardcoded plots (hover labels for desktop only)
const plots = [
  { name: "Plot H1", x: 2829, y: 2567, dataKey: "plot-h1" },
  { name: "Plot H2", x: 2652, y: 2565, dataKey: "plot-h2" },
  { name: "Plot H3", x: 2485, y: 2569, dataKey: "plot-h3" },
  { name: "Plot H4", x: 2320, y: 2570, dataKey: "plot-h4" },
  { name: "Plot H5", x: 2157, y: 2570, dataKey: "plot-h5" },
  { name: "Plot H6", x: 2001, y: 2569, dataKey: "plot-h6" },
  { name: "Plot H7", x: 1842, y: 2569, dataKey: "plot-h7" },
  { name: "Plot H8", x: 1933, y: 2320, dataKey: "plot-h8" },
  { name: "Plot H9", x: 2073, y: 2327, dataKey: "plot-h9" },
  { name: "Plot H10", x: 2226, y: 2331, dataKey: "plot-h10" },
  { name: "Plot H11", x: 2380, y: 2341, dataKey: "plot-h11" },
  { name: "Plot H12", x: 2542, y: 2347, dataKey: "plot-h12" },
  { name: "Plot H13", x: 2708, y: 2354, dataKey: "plot-h13" },
  { name: "Plot H14", x: 2876, y: 2359, dataKey: "plot-h14" },
  { name: "Plot H15", x: 2905, y: 2114, dataKey: "plot-h15" },
  { name: "Plot H16", x: 2776, y: 2110, dataKey: "plot-h16" },
  { name: "Plot H17", x: 2649, y: 2105, dataKey: "plot-h17" },
  { name: "Plot H18", x: 2520, y: 2101, dataKey: "plot-h18" },
  { name: "Plot H19", x: 2391, y: 2096, dataKey: "plot-h19" },
  { name: "Plot H20", x: 2264, y: 2093, dataKey: "plot-h20" },
  { name: "Plot H21", x: 2138, y: 2086, dataKey: "plot-h21" },
  { name: "Plot H22", x: 2019, y: 2080, dataKey: "plot-h22" },
  { name: "Plot H23", x: 2838, y: 1869, dataKey: "plot-h23" },
  { name: "Plot H24", x: 2678, y: 1867, dataKey: "plot-h24" },
  { name: "Plot H25", x: 2507, y: 1865, dataKey: "plot-h25" },
  { name: "Plot H26", x: 2340, y: 1861, dataKey: "plot-h26" },
  { name: "Plot H27", x: 2210, y: 1857, dataKey: "plot-h27" },
  { name: "Plot H28", x: 2103, y: 1857, dataKey: "plot-h28" },
  { name: "Plot H29", x: 2175, y: 1655, dataKey: "plot-h29" },
  { name: "Plot H30", x: 2341, y: 1516, dataKey: "plot-h30" },
  { name: "Plot H31", x: 2442, y: 1539, dataKey: "plot-h31" },
  { name: "Plot H32", x: 2555, y: 1567, dataKey: "plot-h32" },
  { name: "Plot H33", x: 2678, y: 1601, dataKey: "plot-h33" },
  { name: "Plot H34", x: 2825, y: 1633, dataKey: "plot-h34" },
  
]

// Hardcoded plot centers
const plotCenters = [
  { id: "plot-h1", x: 2915.74, y: 2694.37, alt: "plot-h1" },
  { id: "plot-h2", x: 2716.48, y: 2692.12, alt: "plot-h2" },
  { id: "plot-h3", x: 2516.45, y: 2693.27, alt: "plot-h3" },
  { id: "plot-h4", x: 2351.00, y: 2693.70, alt: "plot-h4" },
  { id: "plot-h5", x: 2186.00, y: 2693.70, alt: "plot-h5" },
  { id: "plot-h6", x: 2013.40, y: 2699.60, alt: "plot-h6" },
  { id: "plot-h7", x: 1861.40, y: 2718.60, alt: "plot-h7" },
  { id: "plot-h8", x: 1961.75, y: 2444.25, alt: "plot-h8" },
  { id: "plot-h9", x: 2113.75, y: 2447.25, alt: "plot-h9" },
  { id: "plot-h10", x: 2269.50, y: 2450.25, alt: "plot-h10" },
  { id: "plot-h11", x: 2424.75, y: 2453.50, alt: "plot-h11" },
  { id: "plot-h12", x: 2579.75, y: 2457.00, alt: "plot-h12" },
  { id: "plot-h13", x: 2739.00, y: 2458.50, alt: "plot-h13" },
  { id: "plot-h14", x: 2936.00, y: 2461.00, alt: "plot-h14" },
  { id: "plot-h15", x: 2952.00, y: 2226.50, alt: "plot-h15" },
  { id: "plot-h16", x: 2816.75, y: 2223.75, alt: "plot-h16" },
  { id: "plot-h17", x: 2685.25, y: 2219.00, alt: "plot-h17" },
  { id: "plot-h18", x: 2555.50, y: 2214.75, alt: "plot-h18" },
  { id: "plot-h19", x: 2427.00, y: 2210.25, alt: "plot-h19" },
  { id: "plot-h20", x: 2297.00, y: 2204.75, alt: "plot-h20" },
  { id: "plot-h21", x: 2167.25, y: 2197.00, alt: "plot-h21" },
  { id: "plot-h22", x: 2045.50, y: 2190.25, alt: "plot-h22" },
  { id: "plot-h23", x: 2921.00, y: 1980.50, alt: "plot-h23" },
  { id: "plot-h24", x: 2757.50, y: 1977.25, alt: "plot-h24" },
  { id: "plot-h25", x: 2590.00, y: 1974.50, alt: "plot-h25" },
  { id: "plot-h26", x: 2419.50, y: 1969.75, alt: "plot-h26" },
  { id: "plot-h27", x: 2268.75, y: 1962.25, alt: "plot-h27" },
  { id: "plot-h28", x: 2134.00, y: 1958.50, alt: "plot-h28" },
  { id: "plot-h29", x: 2232.83, y: 1680.00, alt: "plot-h29" },
  { id: "plot-h30", x: 2371.25, y: 1681.25, alt: "plot-h30" },
  { id: "plot-h31", x: 2470.50, y: 1717.25, alt: "plot-h31" },
  { id: "plot-h32", x: 2602.75, y: 1749.25, alt: "plot-h32" },
  { id: "plot-h33", x: 2750.25, y: 1750.75, alt: "plot-h33" },
  { id: "plot-h34", x: 2906.00, y: 1744.25, alt: "plot-h34" },
]

const LocationLabels = ({ labelStyle, getResponsivePosition, coords, onC5Click, onC7Click }) => {
  const [hoveredPlot, setHoveredPlot] = useState(null);
  const [plotStatuses, setPlotStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  useEffect(() => {
    const fetchPlotStatuses = async () => {
      try {
        const plotsCollection = collection(db, "vihaarplots");
        const plotsSnapshot = await getDocs(plotsCollection);
        const statusMap = plotsSnapshot.docs.reduce((acc, doc) => {
          const data = doc.data();
          acc[doc.id] = data.Status || "Unknown";
          return acc;
        }, {});
        setPlotStatuses(statusMap);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching plot statuses from Firestore:", error);
        setPlotStatuses({});
        setLoading(false);
      }
    };

    fetchPlotStatuses();
  }, []);

  useEffect(() => {
    if (!isTouchDevice) {
      const areas = document.querySelectorAll("area[data-key^='plot']");

      const handleMouseOver = (e) => {
        const dataKey = e.target.getAttribute("data-key");
        const plot = plots.find((p) => p.dataKey === dataKey);
        if (plot) setHoveredPlot(plot);
      };
      const handleMouseOut = () => setHoveredPlot(null);

      areas.forEach((area) => {
        area.addEventListener("mouseover", handleMouseOver);
        area.removeEventListener("mouseout", handleMouseOut);
      });

      return () => {
        areas.forEach((area) => {
          area.removeEventListener("mouseover", handleMouseOver);
          area.removeEventListener("mouseout", handleMouseOut);
        });
      };
    }
  }, [isTouchDevice]);

  if (loading) {
    return null; // Render nothing while loading
  }

  return (
    <>
      {tooltips.map((tooltip, index) => {
        const coord = coords[tooltip.coords];
        if (!coord) return null;

        return (
          <div
            key={`tooltip-${index}`}
            className={`persistent-tooltip ${tooltip.className}`}
            onClick={(e) => {
              e.stopPropagation();
              if (tooltip.coords === "c3" && onC5Click) onC5Click();
              else if (tooltip.coords === "c4" && onC7Click) onC7Click();
            }}
            style={{
              ...labelStyle,
              ...getResponsivePosition(coord.x, coord.y),
              transform: tooltip.transform || "none",
              border: tooltip.border || "none",
              cursor: tooltip.coords === "c5" || tooltip.coords === "c7" ? "pointer" : "default",
            }}
          >
            {tooltip.isBold ? (
              <strong>
                {tooltip.name}
                {tooltip.description && <span dangerouslySetInnerHTML={{ __html: tooltip.description }} />}
              </strong>
            ) : (
              <>
                {tooltip.name}
                {tooltip.description && <span dangerouslySetInnerHTML={{ __html: tooltip.description }} />}
              </>
            )}
          </div>
        );
      })}

      {!loading &&
        plotCenters.map((plot, index) => {
          const status = plotStatuses[plot.id] || "Unknown";
          if (status === "Available") return null;

          let backgroundColor;
          if (status === "Sold") backgroundColor = "red";
          else if (status === "Booked") backgroundColor = "orange";
          else backgroundColor = "rgba(36, 35, 35, 0.8)";

          return (
            <div
              key={`plot-center-${index}`}
              className="plot-center-label"
              style={{
                ...labelStyle,
                ...getResponsivePosition(plot.x, plot.y),
                transform: "translate(-50%, -50%)",
                fontSize: "4px",
                color: "White",
                backgroundColor: backgroundColor,
                padding: "3px",
                borderRadius: "1px",
       
              }}
            >
              {`${plot.alt}`}
              <br />
              {`${status}`}
            </div>
          );
        })}

      {!isTouchDevice && hoveredPlot && (
        <div
          className="plot-hover-label"
          style={{
            ...labelStyle,
            ...getResponsivePosition(hoveredPlot.x, hoveredPlot.y),
            transform: "translate(-50%, -50%)",
          }}
        >
          {hoveredPlot.name}
        </div>
      )}
    </>
  );
};

export default LocationLabels;